import { PartnerLinksService } from '@/services/partner-links.service';
import { useQuery } from '@tanstack/react-query';

export function usePartnerProducts(enabled = true) {
  const { data, isLoading } = useQuery({
    queryKey: ['partner-products'],
    queryFn: () => PartnerLinksService.getPartnerProducts({ per_page: 100 }),
    staleTime: 60 * 1000,
    enabled,
  });

  return {
    partnerProducts: data?.data ?? [],
    hasReferralProducts: (data?.data?.length ?? 0) > 0,
    isLoading,
  };
}
